import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import userServices from "../../api/services/userService";
import Loading from "../../components/Loading";
import filterService from "../../api/services/filterService";
import { countries } from "../../data/countries";
const UserProfiles = () => {
  // Filters
  const [filters, setFilters] = useState({
    occupation: "",
    education: "",
    marital: "",
    religion: "",
    minHeight: "",
    maxHeight: "",
    minAge: "",
    maxAge: "",
    radius: "",
    latitude: "",
    longitude: "",
    country: "",
    sort: "",
  });

  // Pagination states
  const [backendPage, setBackendPage] = useState(1);
  const backendLimit = 15;

  // Data states
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Filter lists
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [education, setEducation] = useState([]);
  const [religions, setReligion] = useState([]);
  const [occupation, setOccupation] = useState([]);

  // Handle filter input
  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  // Fetch users (backend page)
  const fetchFilteredUsers = async () => {
    try {
      setIsLoading(true);

      const payload = {
        ...filters,

        // Convert single-select values to array (if not empty)
        occupation: filters.occupation ? [Number(filters.occupation)] : null,
        education: filters.education ? [Number(filters.education)] : null,
        marital: filters.marital ? [Number(filters.marital)] : null,
        religion: filters.religion ? [Number(filters.religion)] : null,

        // Country already array OR empty
        country: filters.country ? [filters.country] : null,

        minHeight: filters.minHeight ? Number(filters.minHeight) : null,
        maxHeight: filters.maxHeight ? Number(filters.maxHeight) : null,
        minAge: filters.minAge ? Number(filters.minAge) : null,
        maxAge: filters.maxAge ? Number(filters.maxAge) : null,

        // Pagination parameters
        page: backendPage,
        limit: backendLimit,
      };

      const result = await userServices.getFilteredUsersAdmin(payload);
      const allUsers = result?.users || [];

      setUsers(allUsers);
      setTotal(result?.total || 0);
    } catch (error) {
      console.error("Error fetching filtered users:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFilteredUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backendPage]);

  useEffect(() => {
    const loadFilterData = async () => {
      const data = await filterService.getAllFilters();
      setMaritalStatus(data.maritalStatus);
      setEducation(data.educations);
      setOccupation(data.occupations);
      setReligion(data.religions);
    };
    loadFilterData();
  }, []);

  return (
    <div className="p-4 w-full">
      {/* FILTER SECTION */}
      <div className="bg-white p-4 rounded shadow mb-4 grid grid-cols-4 gap-4">
        {/* Occupation */}
        <select
          name="occupation"
          value={filters.occupation}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm">
          <option value="">Select Occupations</option>
          {occupation?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Education */}
        <select
          name="education"
          value={filters.education}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm">
          <option value="">Select Education</option>
          {education?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Marital Status */}
        <select
          name="marital"
          value={filters.marital}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm">
          <option value="">Select Marital Status</option>
          {maritalStatus?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Religion */}
        <select
          name="religion"
          value={filters.religion}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm">
          <option value="">Select Religion</option>
          {religions?.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {/* Other filter fields */}
        <input
          type="number"
          name="minAge"
          placeholder="Min Age"
          value={filters.minAge}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />
        <input
          type="number"
          name="maxAge"
          placeholder="Max Age"
          value={filters.maxAge}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />
        <input
          type="number"
          name="minHeight"
          placeholder="Min Height"
          value={filters.minHeight}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />
        <input
          type="number"
          name="maxHeight"
          placeholder="Max Height"
          value={filters.maxHeight}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />

        {/* Countries */}
        <select
          name="country"
          value={filters.country}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm">
          <option value="">Select Countries</option>
          {countries?.map((item) => (
            <option key={item.id} value={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          name="latitude"
          placeholder="Latitude"
          value={filters.latitude}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />
        <input
          type="text"
          name="longitude"
          placeholder="Longitude"
          value={filters.longitude}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />
        <input
          type="number"
          name="radius"
          placeholder="Radius (meters)"
          value={filters.radius}
          onChange={handleFilterChange}
          className="border p-2 rounded text-xs md:text-sm"
        />

        {/* Apply / Clear */}
        <div className="col-span-4 flex justify-between mt-2">
          <button
            onClick={() => {
              setBackendPage(1);
              fetchFilteredUsers();
            }}
            className="bg-red-500 text-white py-2 px-4 rounded text-xs md:text-sm">
            Apply Filters
          </button>

          <button
            onClick={() => {
              setFilters({
                occupation: "",
                education: "",
                marital: "",
                religion: "",
                minHeight: "",
                maxHeight: "",
                minAge: "",
                maxAge: "",
                radius: "",
                latitude: "",
                longitude: "",
                country: "",
                sort: "",
              });
              setBackendPage(1);
              fetchFilteredUsers();
            }}
            className="bg-gray-300 text-black py-2 px-4 rounded text-xs md:text-sm">
            Clear Filters
          </button>
        </div>
      </div>

      {/* TABLE */}
      {isLoading ? (
        <Loading />
      ) : (
        <div className="overflow-x-auto bg-white shadow rounded-lg">
          <table className="w-full text-left border-collapse text-xs md:text-sm">
            <thead className="bg-gray-100 ">
              <tr>
                <th className="px-4 py-2">SR. NO</th>
                <th className="px-4 py-2">First Name</th>
                <th className="px-4 py-2">Last Name</th>
                <th className="px-4 py-2">Email</th>
                <th className="px-4 py-2">Gender</th>
                <th className="px-4 py-2">Contact No</th>
                <th className="px-4 py-2">Age</th>
                <th className="px-4 py-2">Height</th>
                <th className="px-4 py-2">GrewUp</th>
                <th className="px-4 py-2">Occupation</th>
                <th className="px-4 py-2">Actions</th>
              </tr>
            </thead>

            <tbody>
              {users.length > 0 ? (
                users.map((user, idx) => (
                  <tr key={user.id} className="border-t">
                    <td className="px-4 py-2">
                      {(backendPage - 1) * backendLimit + idx + 1}
                    </td>
                    <td className="px-4 py-2">{user.firstName}</td>
                    <td className="px-4 py-2">{user.lastName}</td>
                    <td className="px-4 py-2">{user.email}</td>
                    <td className="px-4 py-2">{user.gender}</td>
                    <td className="px-4 py-2">{user.contactNo}</td>
                    <td className="px-4 py-2">{user.age}</td>
                    <td className="px-4 py-2">{user.height}</td>
                    <td className="px-4 py-2">{user.grewUp}</td>
                    <td className="px-4 py-2">{user.occupation}</td>

                    <td className="px-4 py-2">
                      <FaEye
                        className="text-red-500 cursor-pointer"
                        onClick={() => {
                          window.open(
                            `https://naseebi.com/home/profiledetail/${user.id}`,
                            "_blank"
                          );
                        }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-gray-500">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      {total > 0 && (
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 px-4 py-4 bg-gray-50 rounded-lg border border-gray-200">
          <div className="text-xs md:text-sm font-medium text-gray-700">
            Showing page{" "}
            <span className="font-bold text-gray-900">{backendPage}</span> of{" "}
            <span className="font-bold text-gray-900">
              {Math.ceil(total / backendLimit)}
            </span>{" "}
            (Total: <span className="font-bold text-red-600">{total}</span>{" "}
            users)
          </div>
          <div className="flex gap-2 items-center justify-center">
            <button
              onClick={() => setBackendPage((prev) => Math.max(1, prev - 1))}
              disabled={backendPage === 1}
              className={`px-4 py-2 border rounded-lg font-medium text-xs md:text-sm transition-colors ${
                backendPage === 1
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
                  : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300 hover:border-gray-400"
              }`}>
              Previous
            </button>
            <span className="text-xs md:text-sm text-gray-700">
              <span className="font-bold">
                {(backendPage - 1) * backendLimit + 1}
              </span>{" "}
              -{" "}
              <span className="font-bold">
                {Math.min(backendPage * backendLimit, total)}
              </span>{" "}
              of <span className="font-bold text-red-600">{total}</span>
            </span>
            <button
              onClick={() =>
                setBackendPage((prev) =>
                  Math.min(Math.ceil(total / backendLimit), prev + 1)
                )
              }
              disabled={backendPage >= Math.ceil(total / backendLimit)}
              className={`px-4 py-2 border rounded-lg font-medium text-xs md:text-sm transition-colors ${
                backendPage >= Math.ceil(total / backendLimit)
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200"
                  : "bg-white text-gray-700 hover:bg-gray-50 border-gray-300 hover:border-gray-400"
              }`}>
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserProfiles;
